import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    // Verificar se é uma rota pública que não precisa de autenticação
    const isPublicRoute = state.url.startsWith('/public/') || 
                         state.url.startsWith('/invite/') ||
                         state.url.startsWith('/password/') ||
                         state.url.startsWith('/authentication/') ||
                         state.url === '/unauthorized';
    
    if (isPublicRoute) {
      // Rotas públicas não precisam de token
      return true;
    }

    const token = localStorage.getItem('BearerToken');

    if (token) {
      // temos token → deixa entrar
      return true;
    }

    // sem token → manda para login
    return this.router.createUrlTree(
      ['/authentication/login'],
      { queryParams: { returnUrl: state.url } }
    );
  }
}
